import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function getUserDetailsById(token, api_token,user_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/user/details/${user_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.USER_PROFILE_FOR_OTHERS_REQUEST, types.USER_PROFILE_FOR_OTHERS_RECEIVE, {
                type: types.USER_PROFILE_FOR_OTHERS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetUserDetailsById = () => ({
    type: types.RESET_USER_PROFILE_FOR_OTHERS,
    payload: null
});

